/**
 * @ngdoc service
 * @name roleApiService
 * @module flowingly.runner.services
 *
 * @description A service responsible solely for fetching roles data
 *
 * ## Notes
 * No Caching or formatting to be performed here.
 *
 */

import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';
import IRoleDetail from '@Shared.Angular/@types/core/contracts/queryModel/authorisation/roleDetail';
import IPermissionDetail from '@Shared.Angular/@types/core/contracts/queryModel/authorisation/permissionDetail';
import { ISearchRolesResult } from '@Shared.Angular/@types/core/contracts/queryModel/authorisation/searchRolesResult';
import { Guid } from '@Shared.Angular/@types/guid';

angular
  .module('flowingly.runner.services')
  .factory('roleApiService', roleApiService);

roleApiService.$inject = ['$http', 'APP_CONFIG'];

function roleApiService(
  $http: angular.IHttpService,
  APP_CONFIG: SharedAngular.APP_CONFIG
) {
  const service = {
    getRoles: getRoles,
    searchRoles: searchRoles,
    saveRole: saveRole,
    deleteRole: deleteRole,
    getAllPermissions: getAllPermissions
  };
  const rolesApiBaseUri = APP_CONFIG.apiBaseUrl + 'roles';

  return service;

  function getRoles(noSpinner) {
    return $http
      .get<IRoleDetail[]>(rolesApiBaseUri, {
        noSpinner: noSpinner || false
      })
      .then(function (response) {
        return response.data;
      });
  }

  function searchRoles(options, noSpinner = false) {
    return $http
      .post<ISearchRolesResult>(rolesApiBaseUri + '/v2', options, {
        noSpinner: noSpinner || false
      })
      .then(function (response) {
        return response.data;
      });
  }

  function saveRole(role: IRoleDetail) {
    return $http.put<void>(rolesApiBaseUri, role);
  }

  function deleteRole(roleId: Guid) {
    return $http.delete<void>(rolesApiBaseUri + `/${roleId}`);
  }

  function getAllPermissions() {
    return $http
      .get<IPermissionDetail[]>(rolesApiBaseUri + '/permissions')
      .then((response) => response.data);
  }
}

export type RoleApiServiceType = ReturnType<typeof roleApiService>;
